export const isTutor = (userType: string | undefined) =>
  userType?.toLowerCase() === 'tutor';

export const isStudent = (userType: string | undefined) =>
  userType?.toLowerCase() === 'student';

// Function to format phone number to US format: (XXX) XXX-XXXX
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '');
  // Limit to 10 digits
  const trimmedDigits = digitsOnly.slice(0, 10);

  if (trimmedDigits.length <= 3) {
    return trimmedDigits;
  } else if (trimmedDigits.length <= 6) {
    return `(${trimmedDigits.slice(0, 3)}) ${trimmedDigits.slice(3)}`;
  } else {
    return `(${trimmedDigits.slice(0, 3)}) ${trimmedDigits.slice(3, 6)}-${trimmedDigits.slice(
      6,
    )}`;
  }
};